var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 122.515 122.515",
    xmlSpace: "preserve",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 97.25,
    cy: 12.677,
    r: 12.677
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.684,28.44c-0.211-0.13-0.437-0.223-0.658-0.317c-1.413-0.942-2.999-1.637-4.616-2.033l-3.157,3.179l-3.062-3.214 c-0.012,0.002-0.021,0.002-0.032,0.005c-1.649,0.396-3.267,1.102-4.704,2.066c-0.22,0.094-0.439,0.185-0.65,0.313 c-3.307,2.029-6.065,5.221-8.734,8.309c-6.105,7.066-8.807,9.104-12.77,7.253c-2.463-1.151-5.393-0.089-6.542,2.375 c-1.151,2.462-0.089,5.392,2.375,6.542c2.416,1.129,4.67,1.611,6.774,1.611c5.927,0,10.651-3.818,14.369-7.723v18.288 c0,1.325,0.257,2.561,0.707,3.695c-0.034,0.255-0.058,0.515-0.058,0.779l0.002,47.131c0.002,3.211,2.605,5.816,5.817,5.815 c3.212,0,5.817-2.604,5.817-5.817L96.557,76.25c0.23,0.011,0.461,0.029,0.693,0.029c0.045,0,0.09-0.004,0.135-0.006l-0.002,40.424 c0,3.213,2.604,5.817,5.816,5.817l0,0c3.212,0,5.816-2.604,5.816-5.817l0.003-46.842c0.763-1.412,1.206-3.011,1.206-4.763V49.279 c1.146,4.164,1.611,9.725,1.013,17.384c-0.212,2.709,1.813,5.079,4.524,5.29c0.131,0.011,0.259,0.016,0.389,0.016 c2.544,0,4.699-1.959,4.9-4.539C122.992,42.638,114.813,34.04,105.684,28.44z M97.223,54.361l-3.057-4.184l3.057-20.437h0.059 l3.059,20.437l-3.059,4.184H97.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.887,85.576L6.886,98.066v21.072c0,0.594,0.48,1.075,1.074,1.075h14.573c0.593,0,1.075-0.481,1.075-1.075V86.814 l-3.361-1.236h-1.36V85.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.569,95.372H33.997c-0.593,0-1.074,0.48-1.074,1.075v22.691c0,0.594,0.481,1.075,1.074,1.075h14.571 c0.594,0,1.075-0.481,1.075-1.075V96.447C49.643,95.853,49.162,95.372,48.569,95.372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.26,73.164c-0.916,0-1.808-0.323-2.51-0.909l-2.648-2.213L57.526,80.49v38.648c0,0.594,0.482,1.075,1.074,1.075h14.572 c0.594,0,1.074-0.481,1.074-1.075V72.609c-0.059,0.037-0.113,0.078-0.175,0.109C73.516,73.01,72.887,73.164,72.26,73.164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.593,90.351c0.821,0.3,1.737,0.079,2.328-0.563l22.099-24.109l5.173,4.324c0.252,0.21,0.605,0.249,0.896,0.097 c0.293-0.153,0.463-0.465,0.435-0.793l-1.121-12.534c-0.041-0.447-0.435-0.777-0.883-0.738l-12.532,1.121 c-0.328,0.029-0.607,0.253-0.705,0.567c-0.033,0.104-0.043,0.21-0.034,0.315c0.019,0.211,0.12,0.411,0.29,0.551l5.18,4.33 l-20.993,22.9L18.758,77c-0.801-0.294-1.7-0.086-2.292,0.527L1.775,92.814c-0.822,0.856-0.796,2.217,0.061,3.041 c0.416,0.4,0.953,0.6,1.49,0.6c0.564,0,1.128-0.221,1.549-0.66L18.593,81.52L42.593,90.351z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.edbab71800dbdbe87f006eb887683d98.svg";
export { ForwardRef as ReactComponent };